// services/cache/kitDeProdutosMemoryCache.ts
import { useEffect, useState } from 'react';

import { TypeKitDeProduto } from '../../pages/daf/ProdutosDAF/Produtos/types';
import { getAllKitDeProduto } from '../produtosDAF/kitProdutoService';

let kitDeProdutosCache: TypeKitDeProduto[] | null = null;

/**
 * Getter do cache em memória
 */
export function getKitDeProdutosMemoryCache() {
  return kitDeProdutosCache;
}

/**
 * Setter do cache em memória
 */
export function setKitDeProdutosMemoryCache(data: TypeKitDeProduto[]) {
  kitDeProdutosCache = data;
}

/**
 * Limpa o cache em memória
 */
export function clearKitDeProdutosMemoryCache() {
  kitDeProdutosCache = null;
}

/**
 * Hook de cache para Kits de Produtos
 */
export function useKitDeProdutosCache() {
  const [data, setData] = useState<TypeKitDeProduto[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const cached = getKitDeProdutosMemoryCache();
    if (cached) {
      setData(cached);
      return;
    }

    setLoading(true);
    getAllKitDeProduto()
      .then((result) => {
        setData(result);
        setKitDeProdutosMemoryCache(result);
      })
      .finally(() => setLoading(false));
  }, []);

  return { data, loading };
}
